/**
 * Route Meta Middleware (Global)
 * Handles special route meta properties:
 * - public: Routes accessible without authentication
 * - unauthenticatedOnly: Routes only accessible when NOT logged in (e.g., login page)
 */
export default defineNuxtRouteMiddleware(to => {
  // Skip on server: authStore.user is not populated during SSR (Supabase auth is client-side).
  // Running this check SSR would cause a hydration mismatch: server renders the login page,
  // client detects authentication and redirects to home page, Vue hydrates home page
  // against login page DOM → mismatch.
  if (import.meta.server)
    return

  const authStore = useAuthStore()

  // If route is marked as unauthenticatedOnly (like login/register)
  // and user is authenticated, redirect to home
  if (to.meta.unauthenticatedOnly && authStore.isAuthenticated)
    return navigateTo('/')
})
